import Group from '@/components/Passenger/models/Group';
import Passenger from '@/components/Passenger/models/Passenger';
import TransportationPermission from '@/components/Passenger/models/TransportationPermission';
import Trip from "@/components/Passenger/models/Trip";
import { IEntityMatchResult, IPassengerMatchRequest, ITransportationPermissionMatchRequest } from '@/typings/import';
import { 
  IMovitInstance,
  IPassengerGroup,
  IPassengerGroupWithPassengers,
  IPassengerSearchResult,
  ISchedule,
  ITimetableSearchResult } from "@/typings/timit";
import axios from "axios";

const baseURL = process.env.VUE_APP_API_HOST;

export default {
  passengers: {
    async cancelPassengerTrips(id: number, trips: any) {
      const url = baseURL + `/api/passenger/${id}/trips/cancel`
      const result = await axios.post(url, trips);
      return result.data as any;
    },
    async createPassenger(passenger: Passenger) {
      const url = baseURL + `/api/passenger`;
      const result = await axios.post(url, passenger);
      return result.data as Passenger;
    },
    async getPassengerPassengerGroups(id: number) {
      const url = baseURL + `/api/passenger/${id}/passengerGroups`;
      const result = await axios.get(url);
      return result.data as IPassengerGroup[];
    },
    async getPassengerAvailableDestinationGroups(id: number): Promise<string[]> {
      const url = baseURL + `/api/passenger/${id}/availableDestinationGroups`;
      const result = await axios.get(url);
      return result.data as string[];
    },
    async getPassengersByIds(ids: number[]): Promise<Passenger[]> {
      const url = baseURL + `/api/passenger/byIds`;
      const result = await axios.post(url, ids);
      return result.data.map((x: unknown) => new Passenger(x));
    },
    async getPassengerTrips(id: number, startDate: string, endDate: string, destinationId: number) {
      const url = baseURL + `/api/passenger/${id}/trips?startDate=${startDate}&endDate=${endDate}&destinationId=${destinationId}`
      const result = await axios.get(url);
      return result.data as any;
    },
    async getSsn(id: number) {
      const url = baseURL + `/api/passenger/${id}/ssn`
      const result = await axios.get(url);
      return result.data as string;
    },
    async matchPassengers(request: IPassengerMatchRequest) {
      const searchParams = `?externalId=${request.externalId}&ssn=${request.ssn}&name=${request.name}`;
      const url = baseURL + `/api/passenger/importer/search${searchParams}`;
      const result = await axios.get(url);
      return result.data as Array<IEntityMatchResult<Passenger>>;
    },
    async searchPassengers(search: string, searchParams: any) {
      let url = baseURL + `/api/passenger/search?q=${search}`;
      if (searchParams){
        const searchParamKeys = Object.keys(searchParams);
        if (searchParamKeys.length){
          for(const key of searchParamKeys){
            url = `${url}&${key}=${searchParams[key]}`;
          }
        }
      }
      
      const result = await axios.get(url);
      return result.data as IPassengerSearchResult[];
    },
    async setPassengerSsn(id: number, ssn: string) {
      const url = baseURL + `/api/passenger/${id}/ssn`;
      const result = await axios.post(url, {Ssn: ssn});
      return result.data as string;
    },
    async updatePassenger(passenger: Passenger) {
      const url = baseURL + `/api/passenger/${passenger.id}`;
      const result = await axios.put(url, passenger);
      return result.data as Passenger;
    }
  },
  
  organizations: {
    async getTransportationPermissions(id: string): Promise<TransportationPermission[]> {
      const url = baseURL + `/api/organization/${id}/passengerTransportationPermissions`;
      const result = await axios.get(url);
      return result.data as TransportationPermission[];
    },
    async getServiceProviders(id: string) {
      const url = baseURL + `/api/organization/${id}/instances`;
      const result = await axios.get(url);
      return result.data as IMovitInstance[];
    }
  },

  schedules: {
    async createSchedule(schedule: ISchedule) {
      const url = baseURL + `/api/schedule`;
      const result = await axios.post(url, schedule);
      return result.data as ISchedule;
    },
    async updateSchedule(schedule: ISchedule) {
      const url = baseURL + `/api/schedule`;
      const result = await axios.put(url, schedule);
      return result.data as ISchedule;
    },
    async getPassengerSchedules(passengerId: number) {
      const url = baseURL + `/api/schedule/passenger/${passengerId}`;
      const result = await axios.get(url);
      return result.data as ISchedule[];
    },
  },

  timeTables: {
    async searchTimeTable(search: string) {
      const url = baseURL + `/api/timeTable/search?q=${search}`;
      const result = await axios.get(url);
      return result.data as ITimetableSearchResult[];
    }
  },

  transportationPermissions: {
    async matchTransportationPermissions(request: ITransportationPermissionMatchRequest) {
      const searchParams = `?name=${request.permissionName}`;
      const url = baseURL 
        + `/api/passenger/importer/search/${request.passengerId}/transportationPermissions`
        + searchParams;
      const result = await axios.get(url);
      return result.data as Array<IEntityMatchResult<TransportationPermission>>;
    },
    async createTransportationPermission(ptp: TransportationPermission) {
      const url = baseURL + `/api/passenger/${ptp.passengerId}/transportationPermission`;
      const result = await axios.post(url, ptp);
      return result.data as TransportationPermission;
    },
  }
};
